import EyeCloseIcon from "@pages/profile-v2/assets/icons/EyeClose.jsx";
import EyeOpenIcon from "@pages/profile-v2/assets/icons/EyeOpen.jsx";
import { Input } from "antd";
import React, { useRef, useState } from "react";
import { FloatingLabelInputWrapper } from "./elements";

const FloatingLabelInput = ({ label, onChange, isEmpty, ...props }) => {
	const [isFocused, setIsFocused] = useState(false);
	const [value, setValue] = useState("");
	const inputRef = useRef(null);

	const handleBlur = () => {
		setIsFocused(false);
	};

	const handleFocus = () => {
		setIsFocused(true);
	};

	const handleChange = (e) => {
		setValue(e.target.value);
		if (onChange) {
			onChange(e);
		}
	};

	const handleLabelClick = () => {
		setIsFocused(true);
		inputRef.current.focus();
	};

	return (
		<FloatingLabelInputWrapper
			hasLessBorderRadius={window.HAS_LESS_BORDER_RADIUS}
			isEmpty={isEmpty}
			className={`${isFocused ? "focused" : ""} ${value ? "filled" : ""}`}>
			<label
				className={`${isFocused || value ? "label-focused" : ""}`}
				onClick={handleLabelClick}>
				{label}
			</label>
			<Input.Password
				{...props}
				ref={inputRef}
				onFocus={handleFocus}
				onBlur={handleBlur}
				onChange={handleChange}
				autoComplete="off"
				iconRender={(visible) =>
					isEmpty ? null : visible ? <EyeCloseIcon /> : <EyeOpenIcon />
				}
			/>
		</FloatingLabelInputWrapper>
	);
};

export default FloatingLabelInput;
